import "./styles/_product-slider.scss"
import { ProductCard } from "../common/product-card-class";
import { isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady } from "../utils/dom";
import Swiper from "swiper";
import 'swiper/swiper-bundle.css';

const state = {
    elements: {},
};

function cacheState() {
    state.elements = {
        productCards: document.querySelectorAll('.product-item.product-grid-item'),
        sliderContainers: document.querySelectorAll(".product-slider")
    }
}

function initProductCards() {
    state.elements.productCards.forEach((card) => {
        new ProductCard(card)
    })
}

function initSwipers() {
    state.elements.sliderContainers.forEach(slider => {
        new Swiper(slider, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: slider.dataset.slidesMobile,
            breakpoints: {
                1800: {
                    slidesPerView: slider.dataset.slidesLarge
                },
                990: {
                    slidesPerView: slider.dataset.slidesDesktop
                },
                769: {
                    slidesPerView: slider.dataset.slidesTablet
                },
                600: {
                    slidesPerView: slider.dataset.slidesTabletSmall
                },
            },
            centeredSlides: slider.dataset.centerSlides === "true",
        })
    })
}

function init() {
    const isLoadedBefore = isScriptFullyLoaded("product-slider");
    if (isLoadedBefore) return;
    markScriptFullyLoaded("product-slider");

    cacheState();
    initProductCards();
    initSwipers();
}

onDocumentReady(init)